/* ==========================================================================
   Helpers > Store
   ========================================================================== */

const removeFromStore = (instance, store) => store.filter(item => instance !== item);
const addToStore = (instance, store) => store.push(instance);

module.exports = {
    removeFromStore,
    addToStore
};
